// ES2022 polyfills for older Android WebView and iOS Safari < 15.4.
// Required because the marked library (and other deps) call
// Array.prototype.at / String.prototype.at, which 5+ beta users have hit
// on stale system WebViews. Issued via Sentry: cdl-prep-mobile-1, -2.

if (!Array.prototype.at) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, "at", {
    value: function (n: number) {
      n = Math.trunc(n) || 0;
      if (n < 0) n += this.length;
      if (n < 0 || n >= this.length) return undefined;
      return this[n];
    },
    writable: true,
    configurable: true
  });
}

if (!String.prototype.at) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(String.prototype, "at", {
    value: function (n: number) {
      n = Math.trunc(n) || 0;
      if (n < 0) n += this.length;
      if (n < 0 || n >= this.length) return undefined;
      return this[n];
    },
    writable: true,
    configurable: true
  });
}

export {};
